/* PILSNERISH OS — pz-fill (R19/R20 test, staging template index.dive.json only): a title's letters fill with beer.
 * PZ.titleFill({ root, box, text, fontUrl, target, watch }) -> { destroy, wake, rebuild }
 *   root   section element (QA: root.__lv = fill level 0..1, root.__fill = glyph match numbers)
 *   box    positioned element the canvas is placed in (moves and scales with it, e.g. the R11 COLLABS shrink)
 *   text   element holding the title's text node and the empty baseline marker <i class="pz-fill-bl">
 *   target function -> 0..1, the fill the scroll position asks for (the section decides when it starts and ends)
 * The word is drawn on a canvas over the title; the DOM text stays (screen readers, search) with a transparent fill
 * (box.pz-fill-on, section CSS). Glyphs match the CSS title: computed size, weight, wdth axis (a FontFace of the same
 * Archivo file whose weight/stretch descriptors pin wght/wdth: canvas has no font-variation-settings and WebKit ignores
 * ctx.fontStretch; text is measured on a detached canvas because one inside the title inherits its
 * font-variation-settings), letter-spacing, text-transform and colour; x from the DOM text incl. pair kerning, baseline
 * from the marker, positions divided by the box's current scale. Rebuilt on resize, font loads and size changes;
 * rebuild() after a transform change (the canvas backing follows the drawn scale, so a shrunk title stays sharp).
 * Liquid look from pz-dive (R18): gold #E2B655 -> #A47528, bone foam line, rising bubbles, sine surface waves that
 * slosh with scroll speed, painted source-atop so nothing lands outside the letters. R20: at 1 the surface is above the
 * glyphs and the foam line has thinned out over the last quarter, so the letters are fully gold. <= 60 draws/s (30 when PZ.idle), only while `watch` is on screen, parks
 * when empty; runs under reduced motion (R15 rule). */
(function () {
  'use strict';
  var w = window, d = document, PZ = w.PZ;
  if (!PZ || PZ.titleFill) return;
  var BONE = '#EFECE6', TAU = Math.PI * 2, faces = {};

  /* the title's own Archivo file as a FontFace whose weight/stretch descriptors are the computed wght/wdth */
  function face(url, wt, wd) {
    var k = 'PZ Fill ' + wt + ' ' + wd;
    if (!faces[k]) {
      if (!url || !w.FontFace || !d.fonts) faces[k] = Promise.resolve(null);
      else {
        var ff = new FontFace(k, 'url("' + url + '") format("woff2")', { weight: String(wt), stretch: wd + '%' });
        d.fonts.add(ff);
        faces[k] = ff.load().then(function () { return k; }, function () { return null; });
      }
    }
    return faces[k];
  }

  PZ.titleFill = function (o) {
    var root = o && o.root, box = o && o.box, tx = o && o.text, probe = tx && tx.querySelector('.pz-fill-bl');
    if (!root || !box || !tx || !probe || typeof o.target !== 'function') return null;
    var cv = d.createElement('canvas'), ctx = cv.getContext && cv.getContext('2d');
    if (!ctx) return null;
    cv.className = 'pz-fillcv';
    cv.setAttribute('aria-hidden', 'true');
    /* max-width none: a base canvas rule (max-width 100%) squeezed it when the word is wider than a shrink-wrapped title */
    cv.style.cssText = 'position:absolute;left:0;top:0;display:none;pointer-events:none;max-width:none;max-height:none';
    box.appendChild(cv);
    var mask = null, G = null, R = 1, level = 0, vel = 0, vs = 0, last = 0, t0 = performance.now();
    var raf = 0, on = false, dead = false, bT = 0, gen = 0, bubbles = [];
    for (var b = 0; b < 40; b++) bubbles.push({ x: Math.random(), r: .5 + Math.random(), s: .35 + Math.random() * .6, ph: Math.random() });
    root.__lv = 0;

    function textNode() {
      for (var n = tx.firstChild; n; n = n.nextSibling) if (n.nodeType === 3 && /\S/.test(n.data)) return n;
      return null;
    }
    function fail() { box.classList.remove('pz-fill-on'); cv.style.display = 'none'; mask = null; }
    function build() {
      if (dead) return;
      var cs = getComputedStyle(tx), fs = parseFloat(cs.fontSize) || 0, tn = textNode();
      if (!fs || !tn) return fail();
      var m = /["']wdth["']\s+(-?[\d.]+)/.exec(cs.fontVariationSettings || '');
      var st = {
        fs: fs, wt: Math.round(parseFloat(cs.fontWeight) || 400), wd: m ? +m[1] : (parseFloat(cs.fontStretch) || 100),
        ls: parseFloat(cs.letterSpacing) || 0, up: cs.textTransform === 'uppercase', fam: cs.fontFamily, color: cs.color || BONE
      };
      var my = ++gen;
      face(o.fontUrl, st.wt, st.wd).then(function (fam) { if (!dead && my === gen) layout(st, tn, fam); });
    }
    function layout(st, tn, fam) {
      if (!tn.parentNode) return fail();
      var i0 = tn.data.search(/\S/), raw = tn.data.replace(/\s+$/, '').slice(i0), n = raw.length;
      var txt = st.up ? raw.toUpperCase() : raw;
      var hr = box.getBoundingClientRect(), rg = d.createRange();
      /* the box may be scaled (COLLABS shrink): client rects / k = the box's own (local) CSS px; k from its computed
         transform (the current value, also mid-transition), not offsetWidth, which is rounded */
      var mtx = /matrix\(([^)]+)\)/.exec(getComputedStyle(box).transform || ''), mv = mtx ? mtx[1].split(',').map(parseFloat) : null;
      var kx = mv ? Math.sqrt(mv[0] * mv[0] + mv[1] * mv[1]) : 1, ky = mv ? Math.sqrt(mv[2] * mv[2] + mv[3] * mv[3]) : 1;
      rg.setStart(tn, i0); rg.setEnd(tn, i0 + n);
      if (!hr.width || !kx || !ky || rg.getClientRects().length !== 1) return fail(); // hidden, or the title wrapped: plain text
      var dom = rg.getBoundingClientRect();
      rg.setEnd(tn, i0 + 1);
      var x0 = (rg.getBoundingClientRect().left - hr.left) / kx, base = (probe.getBoundingClientRect().top - hr.top) / ky;
      /* measure and draw on the detached mask canvas: a canvas inside the title inherits its font-variation-settings */
      mask = mask || d.createElement('canvas');
      var c = mask.getContext('2d'), i;
      c.setTransform(1, 0, 0, 1, 0, 0);
      var font = fam ? st.wt + ' ' + st.fs + 'px "' + fam + '"' : st.wt + ' ' + st.fs + 'px ' + st.fam;
      c.font = font;
      if ('letterSpacing' in c) c.letterSpacing = '0px';
      /* glyph i starts where the first i+1 glyphs end minus its own advance (the pair kerning before it counts, as in
         the DOM), plus letter-spacing per glyph; if the canvas face still differs from the DOM (no FontFace support),
         the glyphs are scaled to the DOM width */
      var mt = c.measureText(txt), cw = mt.width, domW = dom.width / kx - st.ls * n;
      var sx = cw > 0 && Math.abs(domW / cw - 1) > .004 ? domW / cw : 1, xs = [];
      for (i = 0; i < n; i++) xs.push(x0 + (c.measureText(txt.slice(0, i + 1)).width - c.measureText(txt.charAt(i)).width) * sx + st.ls * i);
      var asc = mt.actualBoundingBoxAscent || st.fs * .72, desc = mt.actualBoundingBoxDescent || 0;
      var lm = c.measureText(txt.charAt(n - 1));
      var inkL = x0 - Math.max(0, mt.actualBoundingBoxLeft || 0) * sx, inkR = xs[n - 1] + (lm.actualBoundingBoxRight || lm.width) * sx;
      var left = Math.floor(inkL - 3), top = Math.floor(base - asc - 3);
      var cwc = Math.ceil(inkR + 3) - left, chc = Math.ceil(base + desc + 3) - top;
      /* backing pixels per local CSS px: device pixels x the box's drawn scale (a shrunk title is not downsampled) */
      R = Math.min(3, w.devicePixelRatio || 1) * Math.min(1, Math.max(.2, kx));
      cv.style.left = left + 'px'; cv.style.top = top + 'px';
      cv.style.width = cwc + 'px'; cv.style.height = chc + 'px';
      cv.width = Math.max(1, Math.round(cwc * R)); cv.height = Math.max(1, Math.round(chc * R));
      mask.width = cv.width; mask.height = cv.height; // resets the context state
      c.setTransform(R, 0, 0, R, 0, 0);
      c.clearRect(0, 0, cwc, chc);
      c.font = font;
      if ('letterSpacing' in c) c.letterSpacing = '0px';
      c.fillStyle = st.color; c.textBaseline = 'alphabetic';
      for (i = 0; i < n; i++) {
        c.save(); c.translate(xs[i] - left, base - top);
        if (sx !== 1) c.scale(sx, 1);
        c.fillText(txt.charAt(i), 0, 0); c.restore();
      }
      G = { L: inkL - left, R: inkR - left, top: base - asc - top, bot: base + desc - top, W: cwc, H: chc };
      root.__fill = { fs: st.fs, wt: st.wt, wd: st.wd, ls: +st.ls.toFixed(3), face: !!fam, sx: +sx.toFixed(4), domW: +domW.toFixed(2), canvasW: +cw.toFixed(2), res: +R.toFixed(3), scale: +kx.toFixed(4) };
      cv.style.display = 'block';
      draw(performance.now());
      box.classList.add('pz-fill-on');
      last = 0; wake();
    }

    function draw(now) {
      if (!mask || !G) return;
      var c = ctx, t = (now - t0) / 1000;
      c.setTransform(1, 0, 0, 1, 0, 0);
      c.globalCompositeOperation = 'source-over';
      c.clearRect(0, 0, cv.width, cv.height);
      c.drawImage(mask, 0, 0);
      if (level < .001) return;
      /* surface: empty = just under the letters; full = just over them. The foam line thins out over the last quarter
         (gone at 1), so the letters are fully gold at the end and the change is still visible right up to it */
      var h = G.bot - G.top, A = Math.max(1, h * .05) + Math.min(h * .22, Math.abs(vs) * h * .1);
      var q = Math.min(1, Math.max(0, (level - .75) / .25)), F = Math.max(2, h * .12) * (1 - q * q * (3 - 2 * q));
      var y0 = G.bot + A + 1, y1 = G.top - A - 1, sY = y0 + (y1 - y0) * level;
      var Wd = Math.max(1, G.R - G.L), k1 = TAU / (Wd * .9), k2 = TAU / (Wd * .37), k3 = TAU / (Wd * .13), k4 = TAU / (Wd * .11);
      var step = Math.max(1.5, Wd / 160), x, y;
      function surf(x) { return sY + A * (.55 * Math.sin(x * k1 + t * 1.7) + .3 * Math.sin(x * k2 - t * 2.3 + 1.3) + .15 * Math.sin(x * k3 + t * 4.1)); }
      function foam(x) { return surf(x) + F * (.55 + .45 * Math.sin(x * k4 + t * 2)); }
      c.setTransform(R, 0, 0, R, 0, 0);
      c.globalCompositeOperation = 'source-atop';
      /* beer under the surface */
      var g = c.createLinearGradient(0, Math.max(G.top, sY - A), 0, G.bot);
      g.addColorStop(0, '#E2B655'); g.addColorStop(1, '#A47528');
      c.beginPath(); c.moveTo(-2, G.H + 2);
      for (x = -2; x <= G.W + step; x += step) c.lineTo(x, surf(x));
      c.lineTo(G.W + step, G.H + 2); c.closePath();
      c.fillStyle = g; c.fill();
      /* bubbles rise from the bottom of the letters and vanish into the foam */
      c.fillStyle = 'rgba(239, 236, 230, .55)';
      for (var i = 0; i < bubbles.length; i++) {
        var bb = bubbles[i], bx = G.L + bb.x * Wd + Math.sin(t * 2 + bb.ph * 9) * h * .04;
        y = G.bot - ((t * bb.s * h * .8 + bb.ph * h) % h);
        if (y < foam(bx) + 1) continue;
        c.beginPath(); c.arc(bx, y, bb.r * h * .035, 0, TAU); c.fill();
      }
      /* foam line: bone from the surface down to a lumpy, frothy lower edge (none once it has thinned out at full) */
      if (F > .25) {
        c.fillStyle = BONE;
        c.beginPath();
        for (x = -2; x <= G.W + step; x += step) c.lineTo(x, surf(x) - 1);
        for (x = G.W + step; x >= -2; x -= step) c.lineTo(x, foam(x));
        c.closePath(); c.fill();
        var fr = F * .32;
        for (x = G.L - fr; x <= G.R + fr; x += fr * 1.5) {
          var j = Math.sin(x * 1.7 + 0.5) * .5 + .5;
          c.beginPath(); c.arc(x, foam(x) - fr * .2, fr * (.6 + .5 * j), 0, TAU); c.fill();
        }
      }
    }

    function frame(now) {
      raf = 0;
      if (dead || !on || !mask) return;
      var minDt = PZ.idle ? 33 : 15.5; // <= 60 draws/s on 320 Hz screens, 30 when idle
      if (last && now - last < minDt) { raf = requestAnimationFrame(frame); return; }
      var dt = last ? Math.min(.05, (now - last) / 1000) : .016;
      last = now;
      var target = Math.min(1, Math.max(0, +o.target() || 0)), prev = level;
      level += (target - level) * Math.min(1, dt * 6);
      if (Math.abs(target - level) < .0005) level = target;
      vel = (level - prev) / dt;
      vs += (vel - vs) * Math.min(1, dt * 5);
      root.__lv = level;
      draw(now);
      /* park when empty and still (the dry word stays drawn); scroll or wake() restarts it */
      if (level === 0 && target === 0) { vs = 0; return; }
      raf = requestAnimationFrame(frame);
    }
    function wake() { if (on && !raf && !dead && mask) raf = requestAnimationFrame(frame); }
    function soon() { clearTimeout(bT); bT = setTimeout(build, 60); }

    var ro = 'ResizeObserver' in w ? new ResizeObserver(soon) : null;
    if (ro) { ro.observe(tx); if (box !== tx) ro.observe(box); }
    var mo = 'MutationObserver' in w ? new MutationObserver(soon) : null;
    if (mo) mo.observe(tx, { attributes: true, attributeFilter: ['style'] });
    w.addEventListener('resize', soon);
    if (d.fonts) {
      if (d.fonts.ready) d.fonts.ready.then(soon);
      if (d.fonts.addEventListener) d.fonts.addEventListener('loadingdone', soon);
    }
    d.addEventListener('pz:idle', wake);
    var stopIO = PZ.inView(o.watch || root, function (v) {
      on = v; last = 0;
      if (v) { w.addEventListener('scroll', wake, { passive: true }); wake(); }
      else { w.removeEventListener('scroll', wake); cancelAnimationFrame(raf); raf = 0; }
    }, { media: false });
    build();
    return {
      wake: wake,
      rebuild: soon,
      destroy: function () {
        dead = true; stopIO(); cancelAnimationFrame(raf); clearTimeout(bT);
        if (ro) ro.disconnect();
        if (mo) mo.disconnect();
        w.removeEventListener('scroll', wake); w.removeEventListener('resize', soon); d.removeEventListener('pz:idle', wake);
        if (d.fonts && d.fonts.removeEventListener) d.fonts.removeEventListener('loadingdone', soon);
        box.classList.remove('pz-fill-on');
        if (cv.parentNode) cv.parentNode.removeChild(cv);
      }
    };
  };
})();
